import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-none text-sm font-medium transition-colors duration-300 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          // Avenue AR primary — flat solid red, white uppercase text, electric-red hover.
          "font-body uppercase tracking-wider font-medium bg-[#E31B23] text-white hover:bg-[#FF2B35] active:bg-[#C1161D]",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90 uppercase tracking-wider",
        outline:
          // Avenue AR secondary — transparent with hairline border, uppercase text.
          "border border-input bg-transparent uppercase tracking-wider font-medium hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80 uppercase tracking-wider",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        // Explicit branded variants for marketing surfaces / nav.
        ave: "uppercase tracking-wider font-medium bg-[#E31B23] text-white hover:bg-[#FF2B35]",
        "ave-yellow": "uppercase tracking-wider font-medium text-white bg-[var(--ave-red)] hover:brightness-110",
        "ave-red": "uppercase tracking-wider font-medium text-white bg-[var(--ave-red)] hover:brightness-110",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 px-3 text-xs",
        lg: "h-10 px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
